import { FaAssistiveListeningSystems, FaReadme } from "react-icons/fa";
import { GiSnake } from "react-icons/gi";
import { GiSpeaker } from "react-icons/gi";
import { MdQuestionAnswer, MdVideoLibrary } from "react-icons/md";
import { PiPlaceholderFill } from "react-icons/pi";
import { RiSpeakFill } from "react-icons/ri";
import { SiGrammarly } from "react-icons/si";
import { TbHexagonLetterD, TbVocabulary } from "react-icons/tb";

export const TypeToActivityIcon = (type: string) => {
	switch (type) {
		case "reading":
			return FaReadme;
		case "listening":
			return FaAssistiveListeningSystems;
		case "video":
			return MdVideoLibrary;
		case "vocabulary":
			return TbVocabulary;
		case "catch-letter-game":
			return TbHexagonLetterD;
		case "grammar":
			return SiGrammarly;
		case "snake-game":
			return GiSnake;
		case "answer":
			return MdQuestionAnswer;
		case "speaker":
			return GiSpeaker;
		case "speaking":
			return RiSpeakFill;
		default:
			return PiPlaceholderFill;
	}
};
